import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalCloseButton,
    Text,
    VStack,
    Box,
} from '@chakra-ui/react';
import { useEffect } from 'react';

interface LocationMismatchWarningModalProps {
    isOpen: boolean;
    onClose: () => void;
    orderLocationName: string;
    userLocationName: string;
}

const LocationMismatchWarningModal = ({
    isOpen,
    onClose,
    orderLocationName,
    userLocationName
}: LocationMismatchWarningModalProps) => {
    // Auto-dismiss after 5 seconds
    useEffect(() => {
        if (!isOpen) return;
        
        const timer = setTimeout(() => {
            onClose();
        }, 5000);
        return () => clearTimeout(timer);
    }, [isOpen, onClose]);

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered size="md">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader textAlign="center" color="orange.500">Location Mismatch Warning</ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={6}>
                    <VStack align="stretch" spacing={4}>
                        <Box>
                            <Text fontWeight="semibold" mb={3}>
                                Requesting Quotes For:
                            </Text>
                            <Box pl={4} py={2}>
                                <Text>Order Location: <strong>{orderLocationName}</strong></Text>
                                <Text>My Location: <strong>{userLocationName}</strong></Text>
                            </Box>
                        </Box>
                        <Text color="gray.600" fontSize="sm">
                            If this is wrong, please change the location on the EMS file and wait for the fresh order to populate in the dashboard with the latest location.
                        </Text>
                    </VStack>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};

export default LocationMismatchWarningModal;
